var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1MainlyClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462.2 290.4",
    style: {
      enableBackground: "new 0 0 462.2 290.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.6,157.4c21.4,0,38.8-17.4,38.8-38.8S140,79.8,118.6,79.8s-38.8,17.4-38.8,38.8S97.2,157.4,118.6,157.4z M118.6,170.7 c-28.8,0-52.1-23.3-52.1-52.1s23.3-52.1,52.1-52.1s52.1,23.3,52.1,52.1S147.3,170.7,118.6,170.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 187)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-16.1-77.3H16c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C-25-73.3-21-77.3-16.1-77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.2-77.3h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C162.3-73.3,166.3-77.3,171.2-77.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 345.229 71.322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9-64.4H74c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9H41.9c-4.9,0-8.9-4-8.9-8.9l0,0 C33-60.5,37-64.4,41.9-64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.2-64.4h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C220.3-60.5,224.3-64.4,229.2-64.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 -106.229 131.678)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-66.3-45.4h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C-75.1-41.5-71.2-45.4-66.3-45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121-45.4h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9H121c-4.9,0-8.9-4-8.9-8.9l0,0 C112.2-41.5,116.1-45.4,121-45.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124 88)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-5.4-88L-5.4-88c4.9,0,8.9,4,8.9,8.9V-47c0,4.9-4,8.9-8.9,8.9l0,0c-4.9,0-8.9-4-8.9-8.9v-32.1 C-14.3-84-10.3-88-5.4-88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-5.4,100.4L-5.4,100.4c4.9,0,8.9,4,8.9,8.9v32.1c0,4.9-4,8.9-8.9,8.9l0,0c-4.9,0-8.9-4-8.9-8.9v-32.1 C-14.3,104.4-10.3,100.4-5.4,100.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.2,167.5l-3.4,0.5l-1.1-3.2c-10.5-30-38.9-50.6-71.3-50.6c-39.5,0-72.2,30.4-75.2,69.5l-0.3,3.8h-8 c-27.2,0-49.3,22.1-49.3,49.3c0,27.3,22.1,49.3,49.3,49.3h168.4c32.7,0,59.3-26.7,59.3-59.7s-26.6-59.7-59.3-59.7 C395.3,166.8,392.3,167,389.2,167.5L389.2,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,179.2c-1.8,0-4.9,0.3-8.5,0.9l-13.6,2.1l-4.6-13c-9-25.5-32.6-42.9-59.7-42.9c-33.2,0-60.6,25.6-63.2,58.5l-1.2,15.3 h-19.8c-20.8,0-37.7,16.4-37.7,36.6c0,20.3,16.9,37,37.7,37H398c26.3,0,47.7-21.2,47.7-47.3C445.5,200.1,424.9,179.2,399,179.2z  M399,162.6c35.4,0,63.2,28.6,63.2,63.9s-28.9,63.9-64.3,63.9H228.3c-29.8,0-54.3-24-54.3-53.6s24.5-53.3,54.3-53.3h4.4 c3.2-41.1,37.5-73.8,79.8-73.8c35.1,0,64.4,22.8,75.4,54C391.1,163.2,395.6,162.6,399,162.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1MainlyClear);
export default __webpack_public_path__ + "static/media/1_mainly_clear.b53b1ccc8fbae744fd5c850d813c8e20.svg";
export { ForwardRef as ReactComponent };